
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/part/[id]",
      function () {
        return require("private-next-pages/part/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/part/[id]"])
      });
    }
  